<template>
  <div class="customer-quicker" :class="{ private: isPrivate }">
    <el-drawer
      :visible.sync="showBatchFees"
      direction="ttb"
      :size="100"
      :append-to-body="false"
      :modal="false"
      :wrapper-closable="false"
      :show-close="false"
      custom-class="batch-fees-drawer"
    >
      <div slot="title" class="flex items-center justify-between w-full">
        <span>
          <i class="el-icon-menu" />
          Batch Fees
        </span>
        <i
          class="el-icon-close cursor-pointer"
          @click="showBatchFees = false"
        />
      </div>
      <div class="batch-fees flex flex-col gap-1.5">
        <div class="grid grid-cols-12 gap-1">
          <div class="col-span-5 flex items-center gap-1">
            <el-form size="mini" class="e-form" label-position="top">
              <div class="flex items-center gap-1">
                <el-form-item label="Base+Fuel" class="flex-1">
                  <el-input v-model="ar.allBaseFuelTolls" type="number" />
                </el-form-item>
                <el-form-item label="Fuel%" class="w-16">
                  <el-input
                    v-model="ar.allFuelPercent"
                    size="mini"
                    type="number"
                  >
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
                <el-form-item label=" ">
                  <el-button
                    type="primary"
                    plain
                    class="narrow"
                    icon="el-icon-check"
                    @click="syncAllBaseFuelsByPercent"
                  />
                </el-form-item>
              </div>
            </el-form>
            <el-form size="mini" class="e-form" label-position="top">
              <div class="flex items-center gap-1">
                <el-form-item label="Base" class="flex-1">
                  <el-input v-model="ar.allBaseRateToll" type="number" />
                </el-form-item>
                <el-form-item label="Fuel" class="w-14">
                  <el-input
                    v-model="ar.allFuelSurcharge"
                    size="mini"
                    type="number"
                  />
                </el-form-item>
                <el-form-item label=" ">
                  <el-button
                    type="primary"
                    plain
                    class="narrow"
                    icon="el-icon-check"
                    @click="syncAllBaseFuelsByAmount"
                  />
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="col-span-7 flex items-center gap-1">
            <el-form
              v-if="transportStyle == 'dp'"
              size="mini"
              class="e-form"
              label-position="top"
            >
              <div class="flex items-center gap-1">
                <el-form-item label="Drop Fee" class="w-16">
                  <el-input v-model="ar.allDropFee" type="number" />
                </el-form-item>
                <el-form-item label=" ">
                  <el-button
                    type="primary"
                    plain
                    class="narrow"
                    icon="el-icon-check"
                    @click="syncAllDropFees"
                  />
                </el-form-item>
              </div>
            </el-form>
            <el-form size="mini" class="e-form flex-1" label-position="top">
              <div class="flex items-center gap-1">
                <el-form-item label="Accessorial" class="flex-1">
                  <el-select
                    filterable
                    clearable
                    v-model="ar.extra.category_id"
                    :popper-append-to-body="false"
                    class="w-full"
                    @change="initBatchInstance"
                  >
                    <el-option
                      v-for="item in options.categories"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="Instance" class="w-32">
                  <el-input
                    v-model="ar.extra.instance"
                    size="mini"
                    placeholder="Instance"
                  />
                </el-form-item>
                <el-form-item label="Amount" class="w-14">
                  <el-input v-model="ar.extra.amount" type="number" />
                </el-form-item>
                <el-form-item label=" ">
                  <el-dropdown :disabled="!ar.extra.category_id">
                    <el-button type="primary" plain class="narrow">
                      <i class="el-icon-arrow-down"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native="addBatchFee('core')">
                        Add to Core
                      </el-dropdown-item>
                      <el-dropdown-item
                        @click.native="addBatchFee('applicable')"
                      >
                        Add to Applicable
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </el-drawer>
    <div class="box">
      <div class="box-title flex items-center justify-between align-center">
        <div> Customer </div>
        <div
          v-if="editingQuote"
          class="normal-case flex items-center gap-1 text-xs"
        >
          <div v-if="!isPrivate" class="tag flex items-center gap-1">
            <div class="text-blue-600 font-normal">Editing -</div>
            <a class="cancel" @click="resetQuote"> Cancel </a>
          </div>
        </div>
      </div>
      <div class="box-content">
        <el-form
          ref="ar"
          :model="ar"
          size="mini"
          label-position="top"
          :key="ar.key"
        >
          <center class="red" v-if="ar.errors">
            {{ ar.errors }}
            <a
              v-if="readyToQuote"
              @click="customerRate"
              class="text-xs no-underline"
            >
              Click to retry
            </a>
          </center>
          <el-row :gutter="8">
            <el-col :span="4">
              <el-form-item label="Transport">
                <el-select
                  filterable
                  v-model="ar.transport_style"
                  placeholder="Choose Mode"
                  class="full-width"
                  :popper-append-to-body="false"
                  :disabled="editingQuote"
                >
                  <el-option
                    v-for="item in options.modes"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Hub">
                <el-select
                  filterable
                  clearable
                  v-model="ar.hub_id"
                  placeholder="Choose Hub"
                  class="full-width"
                  :disabled="editingQuote"
                >
                  <el-option
                    v-for="item in options.hubs"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5" v-if="regionsSelectionEnabled">
              <el-form-item label="Region">
                <el-select
                  filterable
                  multiple
                  clearable
                  v-model="ar.region_ids"
                  placeholder="Choose Region"
                  class="full-width"
                  :popper-append-to-body="false"
                  :collapse-tags="true"
                  :disabled="editingQuote"
                >
                  <el-option
                    v-for="region in hubRegions"
                    :key="region.id"
                    :label="region.name"
                    :value="region.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="regionsSelectionEnabled ? 7 : 12">
              <el-form-item label="Terminals">
                <el-select
                  filterable
                  multiple
                  clearable
                  v-model="ar.terminal_ids"
                  placeholder="Choose Terminals"
                  class="full-width"
                  :popper-append-to-body="false"
                  :collapse-tags="true"
                  :disabled="editingQuote"
                >
                  <el-checkbox class="select-all" v-model="ar.allTerminals">
                    - Select All -
                  </el-checkbox>
                  <el-option
                    v-for="item in terminals"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <div slot="label" class="destination-query">
                  <slot v-if="cityFixedHub">
                    <div class="flex items-center gap-1">
                      <div>City/State</div>
                      <map-engine
                        :engine="engine"
                        @selectEngine="selectEngine"
                      />
                    </div>
                  </slot>
                  <slot v-else>
                    <div class="flex items-center gap-1">
                      <div>Zip Code</div>
                      <map-engine
                        :engine="engine"
                        @selectEngine="selectEngine"
                      />
                    </div>
                    <a
                      class="text-2xs font-bold no-underline"
                      href="https://www.unitedstateszipcodes.org/"
                      target="_blank"
                    >
                      City & State
                    </a>
                  </slot>
                </div>
                <el-input
                  v-if="editingQuote"
                  v-model="ar.destination"
                  :disabled="true"
                />
                <slot v-else>
                  <div v-if="cityFixedHub" class="relative">
                    <el-input
                      v-if="ar.mapDisabled"
                      v-model="ar.destination"
                      placeholder="Enter (City, State)"
                      @blur="checkCity"
                    />
                    <map-suggest
                      v-else
                      v-model="ar.destination"
                      :engine="engine"
                      :cities="true"
                      @select="selectAddress"
                    />
                    <i
                      class="fas fa-map-location-dot text-sm absolute right-5 top-2 cursor-pointer text-blue-500"
                      :class="{ 'text-gray-300': ar.mapDisabled }"
                      @click="triggerMap"
                    />
                  </div>
                  <map-suggest
                    v-else
                    v-model="ar.destination"
                    :engine="engine"
                    :zipcode="true"
                    @select="selectAddress"
                  />
                </slot>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Size/Type/Weight" class="size-type-weight">
                <div class="equipment-checkboxes">
                  <el-checkbox
                    v-model="ar.tank"
                    class="narrow"
                    :disabled="editingQuote"
                  >
                    <span :class="{ purple: ar.tank }"> Tank </span>
                  </el-checkbox>
                  <el-checkbox
                    v-model="ar.hazardous"
                    class="narrow"
                    :disabled="editingQuote"
                  >
                    <span :class="{ red: ar.hazardous }"> Hazmat </span>
                  </el-checkbox>
                </div>
                <el-select
                  filterable
                  multiple
                  clearable
                  v-model="ar.cargo_weights"
                  placeholder="Choose Size/Type/Weight"
                  class="full-width"
                  :popper-append-to-body="false"
                  :collapse-tags="true"
                  :disabled="editingQuote"
                >
                  <el-option
                    v-for="item in options.cargoWeights"
                    :key="item.id"
                    :value="item.id"
                    :label="`${item.size} ${item.type} (${item.weight})`"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Customer">
                <el-select
                  filterable
                  clearable
                  v-model="ar.customer_id"
                  placeholder="Choose Customer"
                  class="full-width"
                  :popper-append-to-body="false"
                  :disabled="lockedCustomerId"
                >
                  <el-option
                    v-for="item in options.customers"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
                <div
                  v-if="customerInactive"
                  class="absolute right-5 top-1 btn btn-2xs btn-red"
                >
                  <i class="el-icon-warning-outline" />
                  <span class="uppercase"> Inactive </span>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Emails (add new email: write and hit enter)">
                <el-select
                  multiple
                  filterable
                  allow-create
                  default-first-option
                  v-model="ar.emails"
                  class="full-width"
                  :disabled="customerInactive"
                >
                  <el-option
                    v-for="(item, index) in options.contacts"
                    :key="index"
                    :value="item.email"
                    class="two-lines"
                  >
                    <div class="title-1">
                      <div class="flex items-center justify-between w-72">
                        <div>{{ item.name }}</div>
                        <div class="text-2xs">
                          {{ item.ordered | usFormat({ year: "yy" }) }}
                          <el-tag
                            type="success"
                            size="mini"
                            class="w-6 text-center"
                            v-if="item.orders > 0"
                          >
                            {{ item.orders }}
                          </el-tag>
                        </div>
                      </div>
                    </div>
                    <div class="title-2">{{ item.email }}</div>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div class="text-red-500"></div>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Customer Comments">
                <el-input
                  v-model="ar.comments"
                  type="textarea"
                  placeholder="Comments"
                  class="full-width"
                  :autosize="{ minRows: 2, maxRows: 6 }"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Internal Comments">
                <el-input
                  v-model="ar.private_comment"
                  type="textarea"
                  placeholder="Comments"
                  class="full-width"
                  :autosize="{ minRows: 2, maxRows: 6 }"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <slot v-if="!isEmptyData(ar.quotes)">
      <div
        class="box"
        :class="{ quoted: currentQuote?.uuid, invalid: !currentQuote?.valid }"
      >
        <div class="box-title flex items-center justify-between">
          <span>Rating</span>
          <div v-if="currentQuote" class="quote-meta">
            <popover
              componentPath="pages/spot_quotes/tolls"
              width="480"
              placement="left"
              :options="buildTollOptions(currentQuote)"
            >
              <div class="tag">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="16"
                  viewBox="0 0 352 116"
                  role="img"
                  aria-label="TOLL"
                >
                  <path
                    fill="#2563EB"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M 274 20 L 272 22 L 272 24 L 273 25 L 273 26 L 274 27 L 274 29 L 275 30 L 274 31 L 274 34 L 273 35 L 273 38 L 272 39 L 272 41 L 271 42 L 271 45 L 270 46 L 270 49 L 269 50 L 269 52 L 268 53 L 268 56 L 267 57 L 267 59 L 266 60 L 266 63 L 265 64 L 265 66 L 264 67 L 264 70 L 263 71 L 263 73 L 262 74 L 262 77 L 261 78 L 261 80 L 260 81 L 260 83 L 259 84 L 259 85 L 258 86 L 257 86 L 252 91 L 252 93 L 254 95 L 316 95 L 317 94 L 318 94 L 322 90 L 322 88 L 324 85 L 324 82 L 325 81 L 325 78 L 326 77 L 326 75 L 327 74 L 327 69 L 326 68 L 326 67 L 325 67 L 324 66 L 317 66 L 316 67 L 315 67 L 308 74 L 308 75 L 300 83 L 299 83 L 298 84 L 290 84 L 289 83 L 289 81 L 290 80 L 290 77 L 291 76 L 291 74 L 292 73 L 292 70 L 293 69 L 293 67 L 294 66 L 294 63 L 295 62 L 295 60 L 296 59 L 296 56 L 297 55 L 297 53 L 298 52 L 298 49 L 299 48 L 299 46 L 300 45 L 300 42 L 301 41 L 301 39 L 302 38 L 302 35 L 303 34 L 303 32 L 304 31 L 304 30 L 311 24 L 311 21 L 308 19 L 276 19 L 275 20 Z M 199 20 L 199 21 L 198 22 L 198 25 L 200 27 L 200 33 L 199 34 L 199 37 L 198 38 L 198 41 L 197 42 L 197 44 L 196 45 L 196 48 L 195 49 L 195 51 L 194 52 L 194 55 L 193 56 L 193 58 L 192 59 L 192 62 L 191 63 L 191 65 L 190 66 L 190 69 L 189 70 L 189 72 L 188 73 L 188 76 L 187 77 L 187 79 L 186 80 L 186 82 L 185 83 L 185 84 L 180 89 L 179 89 L 179 90 L 178 91 L 178 93 L 180 95 L 242 95 L 243 94 L 244 94 L 247 91 L 247 90 L 249 87 L 249 85 L 250 84 L 250 81 L 251 80 L 251 78 L 252 77 L 252 74 L 253 73 L 253 69 L 250 66 L 243 66 L 242 67 L 239 68 L 237 70 L 237 71 L 232 76 L 232 77 L 226 83 L 225 83 L 224 84 L 215 84 L 214 83 L 215 82 L 215 80 L 216 79 L 216 76 L 217 75 L 217 73 L 218 72 L 218 69 L 219 68 L 219 66 L 220 65 L 220 62 L 221 61 L 221 59 L 222 58 L 222 55 L 223 54 L 223 52 L 224 51 L 224 48 L 225 47 L 225 45 L 226 44 L 226 41 L 227 40 L 227 38 L 228 37 L 228 34 L 229 33 L 229 31 L 234 26 L 235 26 L 236 25 L 236 24 L 237 23 L 237 21 L 234 19 L 202 19 L 201 20 Z M 111 20 L 110 20 L 109 19 L 37 19 L 36 20 L 34 20 L 33 21 L 32 21 L 29 26 L 29 28 L 28 29 L 28 32 L 27 33 L 27 35 L 26 36 L 26 43 L 28 45 L 35 45 L 36 44 L 37 44 L 45 36 L 45 35 L 48 32 L 49 32 L 50 31 L 54 31 L 55 32 L 55 34 L 54 35 L 54 37 L 53 38 L 53 41 L 52 42 L 52 44 L 51 45 L 51 48 L 50 49 L 50 51 L 49 52 L 49 55 L 48 56 L 48 58 L 47 59 L 47 62 L 46 63 L 46 66 L 45 67 L 45 69 L 44 70 L 44 73 L 43 74 L 43 76 L 42 77 L 42 80 L 41 81 L 41 83 L 35 89 L 34 89 L 34 90 L 33 91 L 33 93 L 35 95 L 69 95 L 70 94 L 71 94 L 72 93 L 72 89 L 70 87 L 70 80 L 71 79 L 71 77 L 72 76 L 72 73 L 73 72 L 73 70 L 74 69 L 74 66 L 75 65 L 75 63 L 76 62 L 76 59 L 77 58 L 77 56 L 78 55 L 78 52 L 79 51 L 79 49 L 80 48 L 80 45 L 81 44 L 81 42 L 82 41 L 82 38 L 83 37 L 83 35 L 84 34 L 84 32 L 85 31 L 89 31 L 92 34 L 92 35 L 93 36 L 93 38 L 94 39 L 95 42 L 98 45 L 105 45 L 109 41 L 109 39 L 110 38 L 110 36 L 111 35 L 111 32 L 112 31 L 112 29 L 113 28 L 113 22 Z M 179 23 L 178 23 L 176 21 L 174 21 L 171 19 L 168 19 L 167 18 L 147 18 L 146 19 L 143 19 L 142 20 L 140 20 L 139 21 L 137 21 L 136 22 L 135 22 L 134 23 L 131 24 L 129 26 L 128 26 L 118 36 L 118 37 L 115 40 L 115 41 L 114 42 L 114 43 L 111 48 L 111 50 L 110 51 L 110 53 L 109 54 L 109 56 L 108 57 L 108 61 L 107 62 L 107 78 L 108 79 L 108 81 L 109 82 L 110 85 L 114 89 L 114 90 L 115 90 L 117 92 L 118 92 L 123 95 L 126 95 L 127 96 L 134 96 L 135 97 L 136 97 L 137 96 L 138 97 L 139 97 L 140 96 L 148 96 L 149 95 L 152 95 L 153 94 L 155 94 L 156 93 L 157 93 L 158 92 L 159 92 L 160 91 L 161 91 L 162 90 L 165 89 L 168 86 L 169 86 L 176 79 L 176 78 L 180 73 L 180 72 L 181 71 L 181 70 L 184 65 L 184 63 L 185 62 L 185 60 L 186 59 L 186 57 L 187 56 L 187 52 L 188 51 L 188 38 L 187 37 L 187 34 L 186 33 L 186 32 L 185 31 L 184 28 Z M 157 29 L 160 32 L 160 43 L 159 44 L 159 48 L 158 49 L 158 52 L 157 53 L 157 55 L 156 56 L 156 59 L 155 60 L 155 62 L 154 63 L 154 65 L 153 66 L 153 68 L 152 69 L 152 71 L 151 72 L 151 73 L 150 74 L 150 76 L 149 77 L 149 78 L 147 80 L 147 81 L 143 85 L 142 85 L 141 86 L 137 86 L 134 83 L 134 74 L 135 73 L 135 69 L 136 68 L 136 65 L 137 64 L 137 61 L 138 60 L 138 57 L 139 56 L 139 54 L 140 53 L 140 51 L 141 50 L 141 48 L 142 47 L 142 45 L 143 44 L 143 42 L 144 41 L 144 40 L 145 39 L 146 36 L 150 31 L 151 31 L 153 29 Z"
                  />
                </svg>
              </div>
            </popover>
            <div class="tag">
              {{ currentQuote.miles | toFixed({ digits: 0 }) }} mi
            </div>
            <div v-if="currentQuote.uuid" class="tag">
              <b>REF&nbsp;</b>
              <e-copy
                :text="currentQuote.uuid"
                :show="currentQuote.uuid"
                size="12"
              />
            </div>
            <div v-if="currentQuote.created_date" class="tag">
              {{ currentQuote.created_date | usFormat({ year: "yy" }) }}
            </div>
            <div class="flex items-center tag mini">
              <b class="text-xs">EXPR</b>
              <el-date-picker
                v-model="currentQuote.expired_date"
                size="mini"
                type="date"
                class="text expr-date"
                :clearable="false"
                :disabled="currentQuote.stale"
                :value-format="'yyyy-MM-dd'"
                :format="'MM/dd/yy'"
              />
            </div>
          </div>
        </div>
        <div class="box-content">
          <el-tabs v-model="activeTab" tab-position="right" class="rating-tabs">
            <template v-for="group in quoteGroups">
              <el-tab-pane
                v-for="quote in group.quotes"
                :key="quote.key"
                :name="quote.key"
                lazy
              >
                <div slot="label">
                  <div class="flex flex-col gap-1">
                    <div class="flex items-center justify-between">
                      <div class="flex items-center gap-1 text-xs">
                        <div class="flex items-center gap-1 w-44">
                          <div
                            class="size-3 rounded-full shrink-0"
                            :style="{
                              backgroundColor: group.color,
                            }"
                          />
                          <div class="truncate text-sm">{{ quote.origin }}</div>
                        </div>
                        <i
                          v-if="!quote.valid"
                          class="el-icon-warning-outline red"
                        />
                      </div>
                      <div class="text-sm">
                        {{ coreTotal(quote, "new_amount") | toCurrency }}
                      </div>
                    </div>
                    <div
                      class="text-xs text-gray-500 flex items-center justify-between"
                    >
                      <div>{{ sizeTypeWeight(quote) }}</div>
                      <div class="text-xs text-gray-500">
                        {{ quote.miles | toFixed({ digits: 0 }) }}mi
                      </div>
                    </div>
                  </div>
                </div>
                <div class="quote">
                  <el-form :disabled="quote.stale">
                    <div class="flex flex-col gap-1.5">
                      <div class="fees core">
                        <div class="header">
                          <div class="title"> Core </div>
                          <div class="text-xs italic px-2">
                            {{ quote.destination }}
                          </div>
                        </div>

                        <div class="vs bg-purple-100" v-if="allInRate(quote)">
                          <b class="font-bold uppercase">
                            <div>All In Rate </div>
                          </b>
                          <div class="actions">
                            <div class="links">
                              <el-popconfirm
                                title="Are you sure to delete this fee?"
                                confirmButtonText="Confirm"
                                cancelButtonText="Cancel"
                                @confirm="
                                  deleteFee(
                                    quote,
                                    fetchFee(quote, 'all_in_rate'),
                                  )
                                "
                              >
                                <a
                                  class="el-icon-close ml-3"
                                  slot="reference"
                                />
                              </el-popconfirm>
                            </div>
                            <center class="text-2xs text-red-500">
                              Include core fees below
                            </center>
                          </div>
                          <div>
                            <el-input
                              v-model="
                                fetchFee(quote, 'all_in_rate').new_amount
                              "
                              size="mini"
                              type="number"
                              class="full-width"
                              @change="baseRateChanged(quote)"
                            />
                          </div>
                        </div>

                        <div class="vs" v-if="rateTollMerged(quote)">
                          <b>
                            Base Rate
                            <span class="text-2xs">(+Toll)</span>
                          </b>
                          <div
                            class="col-span-2 flex items-center justify-between"
                          >
                            <div
                              class="text-2xs font-normal italic flex items-center gap-1"
                            >
                              <div class="text-gray-600">
                                {{
                                  fetchFee(quote, "base_rate").amount
                                    | toCurrency
                                }}
                                +
                                <b>
                                  {{
                                    fetchFee(quote, "toll_fee").amount
                                      | toCurrency
                                  }}
                                </b>
                              </div>
                              <div>vs</div>
                              <div class="text-blue-600">
                                {{
                                  fetchFee(quote, "base_rate").new_amount
                                    | toCurrency
                                }}
                                +
                                <el-popover
                                  placement="bottom"
                                  width="200"
                                  trigger="click"
                                >
                                  <div class="flex items-center gap-1 p-2">
                                    <label>Toll Fee</label>
                                    <el-input
                                      v-model="
                                        fetchFee(quote, 'toll_fee').new_amount
                                      "
                                      size="mini"
                                      type="number"
                                      style="width: 100px"
                                      @change="syncBaseTollFuelPercent(quote)"
                                    />
                                  </div>
                                  <a slot="reference" class="no-underline">
                                    {{
                                      fetchFee(quote, "toll_fee").new_amount
                                        | toCurrency
                                    }}
                                    <i class="el-icon-edit text-sm" />
                                  </a>
                                </el-popover>
                              </div>
                            </div>
                            <div>
                              {{ quote.summary.base_tolls | toCurrency }}
                            </div>
                          </div>
                          <div>
                            <el-input
                              v-model="quote.summary.new_base_tolls"
                              size="mini"
                              type="number"
                              class="full-width"
                              :disabled="!!allInRate(quote)"
                              @change="baseRateChanged(quote)"
                            />
                          </div>
                        </div>
                        <div class="vs" v-else>
                          <b> Base Rate </b>
                          <div class="col-span-2 flex justify-end">
                            <div>
                              {{
                                fetchFee(quote, "base_rate").amount | toCurrency
                              }}
                            </div>
                          </div>
                          <div>
                            <el-input
                              v-model="fetchFee(quote, 'base_rate').new_amount"
                              size="mini"
                              type="number"
                              class="full-width"
                              :disabled="!!allInRate(quote)"
                              @change="baseRateChanged(quote)"
                            />
                          </div>
                        </div>
                        <div class="vs">
                          <b>Fuel Surcharge</b>
                          <div class="col-span-2 flex justify-end">
                            <div>
                              {{
                                fetchFee(quote, "fuel_surcharge").amount
                                  | toCurrency
                              }}
                            </div>
                          </div>
                          <div>
                            <el-input
                              v-model="
                                fetchFee(quote, 'fuel_surcharge').new_amount
                              "
                              size="mini"
                              type="number"
                              class="full-width"
                              :disabled="!!allInRate(quote)"
                              @change="fuelSurchargeChanged(quote)"
                            />
                          </div>
                        </div>
                        <div class="vs">
                          <b>Fuel Percent %</b>
                          <div class="col-span-2">
                            {{ quote.summary.fuel_percent }}%
                          </div>
                          <div>
                            <el-input
                              v-model="quote.summary.new_fuel_percent"
                              size="mini"
                              type="number"
                              class="full-width"
                              :disabled="!!allInRate(quote)"
                              @change="fuelPercentChanged(quote)"
                            >
                              <template slot="prepend">%</template>
                            </el-input>
                          </div>
                        </div>
                        <div class="vs base-subtotal">
                          <div class="title">BASE/Fuel SUBTOTAL</div>
                          <div class="text-sm col-span-2 flex justify-end">
                            <div>
                              {{ baseTotal(quote) | toCurrency }}
                            </div>
                          </div>
                          <div class="text-sm flex justify-end">
                            <div class="text-blue-600">
                              {{ newBaseTotal(quote) | toCurrency }}
                            </div>
                          </div>
                        </div>
                        <div
                          v-for="(fee, index) in otherCoreFees(quote)"
                          class="vs"
                          :key="index"
                        >
                          <b>{{ fee.name?.titleize() }}</b>
                          <div class="actions">
                            <div class="links">
                              <a
                                class="el-icon-download"
                                @click="promoteFee(quote, fee, false)"
                              />
                              <el-popconfirm
                                title="Are you sure to delete this fee?"
                                confirmButtonText="Confirm"
                                cancelButtonText="Cancel"
                                @confirm="deleteFee(quote, fee)"
                              >
                                <a class="el-icon-close" slot="reference" />
                              </el-popconfirm>
                            </div>
                            <div class="text-2xs w-32 text-left">
                              {{ fee.instance }}
                            </div>
                            {{ fee.amount | toCurrency }}
                          </div>
                          <div>
                            <el-input
                              v-model="fee.new_amount"
                              size="mini"
                              type="number"
                              class="full-width"
                              :disabled="!!allInRate(quote)"
                            />
                          </div>
                        </div>
                        <div class="vs summary">
                          <div class="title col-span-2">CORE SUBTOTAL</div>
                          <div class="text-base">
                            {{ coreTotal(quote, "amount") | toCurrency }}
                          </div>
                          <div class="text-base">
                            <span class="text-blue-600">
                              {{ coreTotal(quote, "new_amount") | toCurrency }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="fees applicable">
                        <div class="header">
                          <div class="title">If Applicable</div>
                        </div>
                        <div
                          v-for="(fee, index) in applicableFees(quote)"
                          class="vs"
                          :key="index"
                        >
                          <b>{{ fee.name?.titleize() }}</b>
                          <div class="actions">
                            <div class="links">
                              <a
                                class="el-icon-upload2"
                                @click="promoteFee(quote, fee, true)"
                              />
                              <el-popconfirm
                                title="Are you sure to delete this fee?"
                                confirmButtonText="Confirm"
                                cancelButtonText="Cancel"
                                @confirm="deleteFee(quote, fee)"
                              >
                                <a class="el-icon-close" slot="reference" />
                              </el-popconfirm>
                            </div>
                            <div class="text-2xs w-32 text-left">
                              {{ fee.instance }}
                            </div>
                            {{ fee.amount | toCurrency }}
                          </div>
                          <div>
                            <el-input
                              v-model="fee.new_amount"
                              size="mini"
                              type="number"
                              class="full-width"
                            />
                          </div>
                        </div>
                        <div class="vs summary">
                          <div class="title col-span-2"
                            >IF APPLICABLE SUBTOTAL</div
                          >
                          <div class="text-sm">
                            {{ applicableTotal(quote) | toCurrency }}
                          </div>
                          <div class="text-sm">
                            <span class="text-blue-600">
                              {{ newApplicableTotal(quote) | toCurrency }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="single-fee">
                        <el-form size="mini" class="" label-position="top">
                          <div class="flex items-center gap-1">
                            <el-form-item
                              label="Add Accessorial"
                              class="flex-1"
                            >
                              <el-select
                                filterable
                                clearable
                                v-model="quote.category_id"
                                class="w-full"
                                :popper-append-to-body="false"
                                @change="queryAccessorial(quote)"
                              >
                                <el-option
                                  v-for="item in options.categories"
                                  :key="item.id"
                                  :label="item.name"
                                  :value="item.id"
                                />
                              </el-select>
                            </el-form-item>
                            <el-form-item label=" ">
                              <el-input
                                v-model="quote.instance"
                                size="mini"
                                placeholder="Instance"
                              />
                            </el-form-item>
                            <el-form-item label=" " class="w-20">
                              <el-input
                                v-model="quote.amount"
                                type="number"
                                placeholder="Amount"
                              />
                            </el-form-item>
                            <el-form-item label=" ">
                              <el-button
                                type="primary"
                                plain
                                class="narrow"
                                icon="el-icon-plus"
                                @click="addFee(quote)"
                              />
                            </el-form-item>
                          </div>
                        </el-form>
                      </div>
                      <div
                        v-if="!isEmptyData(quote.email_to)"
                        class="px-1 bg-green-100 border -mt-1.5"
                      >
                        <div
                          class="flex items-center gap-0.5 tracking-tight text-xs py-1 truncate"
                        >
                          <i class="fas fa-envelope green" />
                          <e-copy
                            :text="quote.email_to"
                            :show="quote.email_to"
                            size="12"
                          />
                        </div>
                      </div>
                    </div>
                  </el-form>
                </div>
              </el-tab-pane>
            </template>
          </el-tabs>
        </div>
      </div>
    </slot>

    <div
      v-if="isPrivate && !isEmptyData(ar.quotes)"
      class="flex items-center gap-1 justify-end"
    >
      <el-button
        type="primary"
        size="mini"
        :disabled="!hasQuotes"
        @click="toggleBatchFees"
      >
        <i class="el-icon-menu" />
        Batch Fees
      </el-button>
      <el-button
        type="danger"
        size="mini"
        @click="handleQuote('customer', 'save')"
        :disabled="!readyToSave"
      >
        <i class="el-icon-check" />
        Save Quote
      </el-button>
      <el-button
        type="success"
        size="mini"
        @click="handleQuote('customer', 'mail')"
        :disabled="!readyToSend"
      >
        <i class="el-icon-s-promotion" />
        Send Quote
      </el-button>
    </div>
  </div>
</template>
<script>
import { debounce } from "lodash";
import MapEngine from "@/default/pages/maps/engine.vue";
export default {
  name: "CustomerRateQuicker",
  components: {
    MapEngine,
  },
  props: ["uuid", "source"],
  data() {
    return {
      engine: "here",
      ar: { key: 0, quotes: [], extra: {} },
      options: {
        modes: [
          { name: "Live Load", id: "ll" },
          { name: "Drop & Pick", id: "dp" },
        ],
        hubs: [],
        terminals: [],
        cargoWeights: [],
        categories: [],
        customers: [],
        contacts: [],
      },
      currentDest: null,
      cachedCustomerId: null,
      customerInactive: false,
      editingQuote: false,
      showBatchFees: false,
      activeTab: null,
      loading: null,
      debouncedCustomerRate: null,
      colors: [
        "#3cb44b",
        "#4363d8",
        "#f58231",
        "#911eb4",
        "#e6194b",
        "#f032e6",
        "#008080",
        "#9a6324",
        "#800000",
        "#808000",
        "#2a2c33",
        "#857e7e",
        "#5b4d54",
      ],
    };
  },
  created() {
    this.debouncedCustomerRate = debounce(this.customerRate, 500);
  },
  async mounted() {
    await this.loadOptions();
    await this.resetQuote();
    await this.editQuote();
  },
  beforeDestroy() {
    this.debouncedCustomerRate?.cancel();
  },
  watch: {
    hubId(nv, ov) {
      if (nv != ov) {
        if (!this.editingQuote) {
          this.$set(this.ar, "region_ids", []);
          this.$set(this.ar, "allTerminals", false);
          this.$set(this.ar, "terminal_ids", []);
        }
      }
    },
    regionIds(nv, ov) {
      if (nv != ov) {
        if (!this.editingQuote) {
          this.$set(this.ar, "allTerminals", false);
          this.$set(this.ar, "terminal_ids", []);
        }
      }
    },
    allTerminals(nv, ov) {
      if (nv != ov) {
        if (!this.editingQuote) {
          this.ar.terminal_ids = nv ? this.terminals.map((o) => o.id) : [];
        }
      }
    },
    transportStyle(nv, ov) {
      if (nv != ov) this.debouncedCustomerRate();
    },
    hazardous(nv, ov) {
      if (nv != ov) this.debouncedCustomerRate();
    },
    tank(nv, ov) {
      if (nv != ov) this.debouncedCustomerRate();
    },
    terminalIds(nv, ov) {
      if (nv != ov) this.debouncedCustomerRate();
    },
    destination(nv, ov) {
      if (nv != ov) this.debouncedCustomerRate();
    },
    cargoWeights(nv, ov) {
      if (nv != ov) this.debouncedCustomerRate();
    },
    engine(nv, ov) {
      if (nv != ov) this.debouncedCustomerRate();
    },
    customer(nv, ov) {
      if (nv != ov) {
        this.loadContacts();
        this.debouncedCustomerRate();
      }
    },
    readyToSave() {
      this.emitQuoteActions();
    },
    readyToSend() {
      this.emitQuoteActions();
    },
    hasQuotes() {
      this.emitQuoteActions();
    },
  },
  computed: {
    isPrivate() {
      return this.source;
    },
    hubTerminals() {
      return this.options.terminals.filter((o) => o.hub_id == this.hubId);
    },
    hubRegions() {
      const regions = [];
      const hub = this.options.hubs.find((o) => o.id == this.hubId);
      if (hub?.regions) regions.push(...hub.regions);
      if (this.hubTerminals.some((o) => !o.region_id))
        regions.push({ id: null, name: "Others" });
      return regions;
    },
    regionsSelectionEnabled() {
      return this.hubRegions.length > 1;
    },
    terminals() {
      const terminals = this.hubTerminals;
      if (this.hubRegions.length <= 1) return terminals;
      const regionIds = this.ar.region_ids;
      if (this.isEmptyData(regionIds)) return [];
      return terminals.filter((t) => regionIds.includes(t.region_id));
    },
    categoryName() {
      return function (id) {
        let category = this.options.categories.find((o) => o.id == id);
        return category ? category.name : "";
      };
    },
    transportStyle() {
      return this.ar.transport_style;
    },
    hazardous() {
      return this.ar.hazardous;
    },
    tank() {
      return this.ar.tank;
    },
    hubId() {
      return this.ar.hub_id;
    },
    hub() {
      return this.options.hubs.find((o) => o.id == this.hubId) || {};
    },
    regionIds() {
      return this.ar.region_ids;
    },
    allTerminals() {
      return this.ar.allTerminals;
    },
    terminalIds() {
      return this.ar.terminal_ids;
    },
    destination() {
      return this.ar.destination;
    },
    customer() {
      return this.ar.customer_id;
    },
    cargoWeights() {
      return this.ar.cargo_weights;
    },
    destReady() {
      return this.ar.destReady;
    },
    originQuotes() {
      return this._.groupBy(this.ar.quotes, "origin");
    },
    cityFixedHub() {
      return this.hub.quote_mode == "city_fixed";
    },
    cityFixedMode() {
      return function (quote) {
        return quote.quote_mode == "city_fixed";
      };
    },
    rateTollMerged() {
      return function (quote) {
        return (
          !this.cityFixedMode(quote) && this.fetchFee(quote, "toll_fee")?.core
        );
      };
    },
    sizeTypeWeight() {
      return function (quote) {
        return `${quote.csize} ${quote.creefer ? "RF" : "DRY"} ${
          quote.cweight
        }`;
      };
    },
    feeIdentifier() {
      return function (quote) {
        const fees = JSON.parse(JSON.stringify(quote.fees || []));
        const core = [];
        const applicable = [];

        fees.forEach((fee) => (fee.core ? core : applicable).push(fee));

        let mergableTollFee;
        if (this.rateTollMerged(quote)) {
          const index = core.findIndex((o) => o.name == "toll_fee");
          if (index >= 0) mergableTollFee = core.splice(index, 1)[0];
        }

        const parts = [core, applicable]
          .map((fees, index) =>
            fees.map((fee) => {
              if (!fee.id) return null;
              let instance = String(fee.instance || "");
              instance = instance.trim().toLowerCase();
              let amount = parseFloat(fee.amount);
              let new_amount = parseFloat(fee.new_amount);

              if (fee.name == "base_rate" && mergableTollFee) {
                amount = this.sumArray([amount, mergableTollFee.amount]);
                new_amount = this.sumArray([
                  new_amount,
                  mergableTollFee.new_amount,
                ]);
              }

              if (!quote.uuid) amount = 0;
              const keys = [fee.id, index === 0, amount, new_amount, instance];
              return keys.map((value) => String(value)).join(":");
            }),
          )
          .flat()
          .filter(Boolean)
          .sort();
        if (quote.expired_date) parts.push(quote.expired_date);
        return parts.join("+");
      };
    },
    quoteGroups() {
      const grouped = this._.groupBy(this.ar.quotes, (quote) =>
        this.feeIdentifier(quote),
      );
      return Object.entries(grouped).map(([identifier, quotes], index) => ({
        identifier,
        quotes,
        color: this.groupColor(index),
      }));
    },
    groupColor() {
      return function (index) {
        return this.colors[index % this.colors.length];
      };
    },
    allInRate() {
      return function (quote) {
        return quote.fees.find((o) => o.name == "all_in_rate");
      };
    },
    coreTotal() {
      return function (quote, target) {
        if (this.isEmptyData(quote)) return 0.0;
        const fees = quote.fees.filter((o) => o["core"]);
        const valid = this.isEmptyData(
          fees.filter((o) => Number.isNaN(o.new_amount)),
        );
        this.$set(quote, "valid", valid);
        return this._.sum(fees.map((o) => parseFloat(o[target]) || 0.0));
      };
    },
    baseTotal() {
      return function (quote) {
        let fees = [];
        const baseRate = this.fetchFee(quote, "base_rate");
        const fuelSurcharge = this.fetchFee(quote, "fuel_surcharge");
        const tollFee = this.fetchFee(quote, "toll_fee");
        fees.push(parseFloat(baseRate.amount));
        fees.push(parseFloat(fuelSurcharge.amount));
        if (this.rateTollMerged(quote)) {
          fees.push(parseFloat(tollFee.amount));
        }
        return this.sumArray(fees);
      };
    },
    newBaseTotal() {
      return function (quote) {
        let fees = [];
        const baseRate = this.fetchFee(quote, "base_rate");
        const fuelSurcharge = this.fetchFee(quote, "fuel_surcharge");
        const tollFee = this.fetchFee(quote, "toll_fee");
        fees.push(parseFloat(baseRate.new_amount));
        fees.push(parseFloat(fuelSurcharge.new_amount));
        if (this.rateTollMerged(quote)) {
          fees.push(parseFloat(tollFee.new_amount));
        }
        return this.sumArray(fees);
      };
    },
    applicableTotal() {
      return function (quote) {
        return this.sumArray(
          this.applicableFees(quote).map((o) => parseFloat(o.amount)),
        );
      };
    },
    newApplicableTotal() {
      return function (quote) {
        return this.sumArray(
          this.applicableFees(quote).map((o) => parseFloat(o.new_amount)),
        );
      };
    },
    otherFees() {
      return function (quote) {
        const excludes = ["base_rate", "fuel_surcharge"];
        if (!quote.drop_pull) excludes.push("drop_fee");
        if (!quote.hazardous) excludes.push("hazardous");
        if (!quote.tank) excludes.push("tanker");
        return quote.fees
          .filter((o) => !excludes.includes(o.name) || o.manual)
          .filter((o) => o.name != "all_in_rate");
      };
    },
    otherCoreFees() {
      return function (quote) {
        const fees = this.otherFees(quote).filter((o) => o.core);
        if (this.rateTollMerged(quote)) {
          const index = fees.findIndex((o) => o.name == "toll_fee");
          if (index >= 0) fees.splice(index, 1);
        }
        return fees;
      };
    },
    applicableFees() {
      return function (quote) {
        return this.otherFees(quote).filter((o) => !o.core);
      };
    },
    fetchFee() {
      return function (quote, name) {
        return quote.fees.find((o) => o.name == name);
      };
    },
    lockedCustomerId() {
      return !!this.cachedCustomerId && this.editingQuote;
    },
    readyToQuote() {
      return (
        !this.isEmptyData(this.terminalIds) &&
        !this.isEmptyData(this.destination) &&
        !this.isEmptyData(this.cargoWeights) &&
        this.customer &&
        this.destReady
      );
    },
    readyToSave() {
      return (
        this.ar.quotes.filter((o) => o.valid).length == this.ar.quotes.length
      );
    },
    readyToSend() {
      return (
        this.ar.quotes.filter((o) => o.valid).length == this.ar.quotes.length &&
        !this.isEmptyData(this.ar.emails)
      );
    },
    hasQuotes() {
      return !this.isEmptyData(this.ar.quotes);
    },
    currentQuote() {
      return (
        this.ar.quotes.find((quote) => quote.key === this.activeTab) || null
      );
    },
  },
  methods: {
    loadingService() {
      return this.$loading.service({
        target: ".customer-quicker",
        lock: true,
        text: "Please wait while generating quotes",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.8)",
      });
    },
    selectEngine(engine) {
      this.engine = engine;
    },
    initQuotes(quotes) {
      const list = (quotes || []).map((quote, index) => {
        this.$set(quote, "key", String(index));
        return quote;
      });
      this.$set(this.ar, "quotes", list);
      this.activeTab = list[0] ? list[0].key : null;
      if (!list.length) this.showBatchFees = false;
    },
    async loadOptions() {
      try {
        let response = await this.$http.get("/api/v1/maps/engine.json");
        this.engine = response.data.name;
        response = await this.$http.get("/api/v1/options.json", {
          params: { targets: ["hubs", "cargo_weights"] },
        });
        this.$set(this.options, "hubs", response.data.hubs);
        this.$set(this.options, "cargoWeights", response.data.cargo_weights);

        response = await this.$http.get("/api/v1/options.json", {
          params: { target: "customers", active: true },
        });
        this.$set(this.options, "customers", response.data);

        response = await this.$http.get("/api/v1/options.json", {
          params: { target: "terminals", active: true, public: true },
        });
        this.$set(this.options, "terminals", response.data);

        response = await this.$http.get("/api/v1/base_rates/categories");
        this.$set(this.options, "categories", response.data);
      } catch (ex) {}
    },
    async loadCustomersWithId(id) {
      try {
        let response = await this.$http.get("/api/v1/options.json", {
          params: { target: "customers", id: id, active: true },
        });
        this.$set(this.options, "customers", response.data);
      } catch (ex) {}
    },
    async loadContacts() {
      try {
        this.ar.emails = [];
        this.options.contacts = [];
        if (this.customer) {
          let response = await this.$http.get(
            `/api/v1/customers/${this.customer}/contacts.json`,
            { params: { target: "email" } },
          );
          this.$set(this.options, "contacts", response.data);
        }
      } catch (ex) {}
    },
    triggerMap() {
      this.$set(this.ar, "mapDisabled", !this.ar.mapDisabled);
    },
    checkCity() {
      let { destination } = this.ar;
      if (destination) {
        let [city, state] = destination.split(",").map((o) => o.trim());
        city = city
          .split(/\s/)
          .map((o) => o?.titleize())
          .join(" ");
        if (state) state = state.toUpperCase();
        destination = [city, state].join(", ");
        this.$set(this.ar, "destination", destination);
      }
      this.ar.destReady = !this.isEmptyData(destination);
    },
    selectAddress(item) {
      this.$set(this.ar, "destReady", !this.isEmptyData(item));
    },
    baseRateToll(quote) {
      const baseRate = this.fetchFee(quote, "base_rate");
      if (this.rateTollMerged(quote)) return quote.summary.new_base_tolls;
      return baseRate.new_amount;
    },
    baseRateChanged(quote) {
      const baseTotal = parseFloat(this.baseRateToll(quote)) || 0.0;
      const baseRate = this.fetchFee(quote, "base_rate");
      const fuelSurcharge = this.fetchFee(quote, "fuel_surcharge");
      const tollFee = this.fetchFee(quote, "toll_fee");
      const fuelPercent =
        parseFloat(quote.summary.new_fuel_percent) / 100.0 || 0.0;

      if (this.rateTollMerged(quote)) {
        if (baseTotal < baseRate.amount) {
          tollFee.new_amount = 0;
        } else {
          tollFee.new_amount = tollFee.amount;
        }
        baseRate.new_amount = baseTotal - tollFee.new_amount;
      }
      fuelSurcharge.new_amount = parseFloat(
        (baseTotal * fuelPercent).toFixed(2),
      );
    },
    fuelSurchargeChanged(quote) {
      const baseTotal = parseFloat(this.baseRateToll(quote)) || 0.0;
      const fuelSurcharge = this.fetchFee(quote, "fuel_surcharge");
      quote.summary.new_fuel_percent = parseFloat(
        ((parseFloat(fuelSurcharge.new_amount) / baseTotal) * 100.0).toFixed(2),
      );
    },
    fuelPercentChanged(quote) {
      let baseTotal = parseFloat(this.baseRateToll(quote)) || 0.0;
      let fuelPercent =
        parseFloat(quote.summary.new_fuel_percent) / 100.0 || 0.0;
      const fuelSurcharge = this.fetchFee(quote, "fuel_surcharge");
      fuelSurcharge.new_amount = parseFloat(
        (baseTotal * fuelPercent).toFixed(2),
      );
    },
    syncBaseTollFuelPercent(quote) {
      const baseRate = this.fetchFee(quote, "base_rate");
      const fuelSurcharge = this.fetchFee(quote, "fuel_surcharge");
      const tollFee = this.fetchFee(quote, "toll_fee");
      if (this.rateTollMerged(quote)) {
        quote.summary.new_base_tolls =
          parseFloat(baseRate.new_amount) + parseFloat(tollFee.new_amount);
        quote.summary.base_tolls =
          parseFloat(baseRate.amount) + parseFloat(tollFee.amount);
      } else {
        quote.summary.new_base_tolls = parseFloat(baseRate.new_amount);
        quote.summary.base_tolls = parseFloat(baseRate.amount);
      }

      const newFuelPercent =
        parseFloat(fuelSurcharge.new_amount) /
        parseFloat(quote.summary.new_base_tolls);
      quote.summary.new_fuel_percent = (newFuelPercent * 100).toFixed(2);

      const fuelPercent =
        parseFloat(fuelSurcharge.amount) / parseFloat(quote.summary.base_tolls);
      quote.summary.fuel_percent = (fuelPercent * 100).toFixed(2);
    },
    syncAllBaseFuelsByPercent() {
      let total = parseFloat(this.ar.allBaseFuelTolls);
      let fuelPercent = parseFloat(this.ar.allFuelPercent);
      if (!Number.isNaN(total) && !Number.isNaN(fuelPercent)) {
        let baseTotal = parseFloat(
          (total / (1 + fuelPercent / 100.0)).toFixed(2),
        );
        this.ar.quotes.forEach((quote) => {
          const baseRate = this.fetchFee(quote, "base_rate");
          const fuelSurcharge = this.fetchFee(quote, "fuel_surcharge");
          const tollFee = this.fetchFee(quote, "toll_fee");
          if (this.rateTollMerged(quote)) {
            if (baseTotal < baseRate.amount) {
              tollFee.new_amount = 0;
            } else {
              tollFee.new_amount = tollFee.amount;
            }
            quote.summary.new_base_tolls = baseTotal;
            baseRate.new_amount = baseTotal - tollFee.new_amount;
          } else {
            baseRate.new_amount = baseTotal;
          }
          fuelSurcharge.new_amount = (total - baseTotal).toFixed(2);
          quote.summary.new_fuel_percent = fuelPercent;
        });
      }
      this.ar.allBaseFuelTolls = null;
      this.ar.allFuelPercent = null;
    },
    syncAllBaseFuelsByAmount() {
      let baseTolls = parseFloat(this.ar.allBaseRateToll);
      let allFuelSurcharge = parseFloat(this.ar.allFuelSurcharge);
      if (!Number.isNaN(baseTolls) && !Number.isNaN(allFuelSurcharge)) {
        let fuelPercent = parseFloat(
          ((allFuelSurcharge / baseTolls) * 100.0).toFixed(2),
        );
        this.ar.quotes.forEach((quote) => {
          const baseRate = this.fetchFee(quote, "base_rate");
          const fuelSurcharge = this.fetchFee(quote, "fuel_surcharge");
          const tollFee = this.fetchFee(quote, "toll_fee");

          if (this.rateTollMerged(quote)) {
            if (baseTolls < baseRate.amount) {
              tollFee.new_amount = 0;
            } else {
              tollFee.new_amount = tollFee.amount;
            }
            quote.summary.new_base_tolls = baseTolls;
            baseRate.new_amount = baseTolls - tollFee.new_amount;
          } else {
            baseRate.new_amount = baseTolls;
          }
          fuelSurcharge.new_amount = allFuelSurcharge;
          quote.summary.new_fuel_percent = fuelPercent;
        });
        this.ar.allBaseRateToll = null;
        this.ar.allFuelSurcharge = null;
      }
    },
    syncAllDropFees() {
      let dropFee = parseFloat(this.ar.allDropFee);
      this.ar.quotes.forEach((quote) => {
        let fee = this.fetchFee(quote, "drop_fee");
        if (fee) this.$set(fee, "new_amount", dropFee);
      });
      this.ar.allDropFee = null;
    },
    initBatchInstance() {
      let category = null;
      const { category_id } = this.ar.extra;
      category = this.options.categories.find((o) => o.id === category_id);
      this.$set(this.ar.extra, "instance", category?.instance);
    },
    async addBatchFee(command) {
      const { category_id, instance, amount } = this.ar.extra;
      const parsed = parseFloat(amount);
      const hasManualAmount = Number.isFinite(parsed) && parsed !== 0;

      for (const quote of this.ar.quotes) {
        this.$set(quote, "category_id", category_id);
        this.$set(quote, "instance", instance);
        this.$set(quote, "core", command == "core");
        if (hasManualAmount) {
          this.$set(quote, "amount", amount);
        } else {
          this.$set(quote, "amount", null);
          await this.queryAccessorial(quote);
        }
        this.addFee(quote);
      }
      this.ar.extra = {};
    },
    addFee(quote) {
      const { category_id, instance, amount, core } = quote;
      if (category_id && amount) {
        const name = this.categoryName(category_id);
        const category = name.replace(/\s/g, "_").toLowerCase();
        const existing =
          this.fetchFee(quote, category) ||
          quote.fees.find((o) => o.id == category_id);
        const isAllIn = category == "all_in_rate";

        if (isAllIn && !existing) {
          quote.fees.filter((o) => o.core).forEach((o) => (o.new_amount = 0));
          quote.summary.new_fuel_percent = 0;
        }

        const fee = {
          id: category_id,
          name: category,
          amount: isAllIn ? 0 : amount,
          new_amount: amount,
          instance: instance,
          core: isAllIn ? true : core,
          manual: true,
          details: existing?.details ?? null,
        };
        if (existing) {
          Object.assign(existing, fee);
        } else {
          quote.fees.push(fee);
        }
      }

      // Reset the form
      this.$set(quote, "category_id", null);
      this.$set(quote, "instance", null);
      this.$set(quote, "amount", null);
      this.$set(quote, "core", null);
    },
    deleteFee(quote, fee) {
      const index = quote.fees.indexOf(fee);
      if (index > -1) quote.fees.splice(index, 1);
      this.syncBaseTollFuelPercent(quote);
    },
    promoteFee(quote, fee, core) {
      fee.core = core;
      if (this.allInRate(quote)) fee.new_amount = 0;
      this.syncBaseTollFuelPercent(quote);
    },
    async customerRate() {
      try {
        if (this.editingQuote) return;
        if (this.loading) return;
        if (this.readyToQuote) {
          this.loading = this.loadingService();
          this.$set(this.ar, "errors", null);
          this.$set(this.ar, "quote", {});
          let response = await this.$http.post("/api/v1/base_rates/customer", {
            engine: this.engine,
            quote: {
              customer_id: this.customer,
              hub_id: this.hubId,
              terminal_ids: this.terminalIds,
              destination: this.destination,
              cargo_weights: this.ar.cargo_weights,
              transport_style: this.ar.transport_style,
              hazardous: this.ar.hazardous,
              tank: this.ar.tank,
            },
          });
          this.initQuotes(response.data);
        } else {
          this.initQuotes([]);
        }
      } catch (err) {
        const errors = err?.response?.data?.errors || err?.message;
        this.$set(this.ar, "errors", errors);
        this.initQuotes([]);
      } finally {
        this.loading?.close();
        this.loading = null;
      }
    },
    async editQuote() {
      try {
        if (!this.uuid) return;
        this.customerInactive = false;
        let quotes = (
          await this.$http.post("/api/v1/base_rates/customer", {
            uuid: this.uuid,
          })
        ).data;

        if (!this.isEmptyData(quotes)) {
          let terminalIds = this._.uniq(quotes.map((o) => o.terminal_id));
          let cargoWeights = this._.uniqBy(
            quotes.map((o) => o.cargo_weight_id),
          );

          this.ar.key++;
          this.$set(this.ar, "extra", {});
          this.$set(this.ar, "transport_style", quotes[0].transport_style);
          this.$set(this.ar, "hazardous", quotes[0].hazardous);
          this.$set(this.ar, "tank", quotes[0].tank);
          this.$set(this.ar, "hub_id", quotes[0].hub_id);
          this.$set(this.ar, "customer_id", quotes[0].customer_id);
          this.$set(this.ar, "destination", quotes[0].destination);
          this.$set(this.ar, "terminal_ids", terminalIds);
          this.$set(this.ar, "cargo_weights", cargoWeights);
          this.$set(this.ar, "comments", quotes[0].comment);
          this.$set(this.ar, "private_comment", quotes[0].private_comment);
          this.initQuotes(quotes);

          const regions = new Set();
          this.hubTerminals
            .filter((o) => terminalIds.includes(o.id))
            .forEach((o) => {
              regions.add(o.region_id);
            });

          this.$set(this.ar, "region_ids", Array.from(regions));

          this.cachedCustomerId = quotes[0].customer_id;
          const customer = this.options.customers.find(
            (o) => o.id === this.cachedCustomerId,
          );
          if (!customer) {
            await this.loadCustomersWithId(this.cachedCustomerId);
            this.customerInactive = true;
          }

          this.editingQuote = true;
        }
      } catch (ex) {
        console.log(ex);
      }
    },
    async queryAccessorial(quote) {
      try {
        let response = await this.$http.post("/api/v1/base_rates/customer", {
          accessorial: {
            hub_id: quote.hub_id,
            customer_id: quote.customer_id,
            terminal_id: quote.terminal_id,
            destination: quote.destination,
            category_id: quote.category_id,
            miles: quote.miles,
            hazardous: quote.hazardous,
            tank: quote.tank,
          },
          target: "accessorial",
        });
        const category = this.options.categories.find(
          (o) => o.id === quote.category_id,
        );
        this.$set(quote, "instance", category?.instance);
        this.$set(quote, "amount", response.data.amount);
      } catch (err) {}
    },
    resetQuote() {
      this.ar.key++;
      const hubid =
        this.options.hubs.length == 1 ? this.options.hubs[0].id : null;
      this.$set(this.ar, "transport_style", "ll");
      this.$set(this.ar, "hub_id", hubid);
      this.$set(this.ar, "region_ids", []);
      this.$set(this.ar, "terminal_ids", []);
      this.$set(this.ar, "destination", null);
      this.$set(this.ar, "cargo_weights", []);
      this.$set(this.ar, "hazardous", false);
      this.$set(this.ar, "tank", false);
      this.$set(this.ar, "customer_id", null);
      this.$set(this.ar, "emails", null);
      this.$set(this.ar, "comments", null);
      this.$set(this.ar, "private_comment", null);
      this.initQuotes([]);
      this.$set(this.ar, "errors", null);
      this.editingQuote = false;
      if (this.customerInactive) {
        const index = this.options.customers.findIndex(
          (o) => o.id == this.cachedCustomerId,
        );
        this.options.customers.splice(index, 1);
        this.customerInactive = false;
      }
    },
    emitQuoteActions() {
      this.$emit("quote-actions", {
        readyToSave: this.hasQuotes && this.readyToSave,
        readyToSend: this.hasQuotes && this.readyToSend,
        hasQuotes: this.hasQuotes,
      });
    },
    toggleBatchFees() {
      if (!this.hasQuotes) return;
      this.showBatchFees = !this.showBatchFees;
    },
    closeBatchFees() {
      this.showBatchFees = false;
    },
    async handleQuote(target, intent) {
      try {
        if (target == "customer") {
          let { quotes, ...params } = this.ar;
          quotes = quotes.map((quote) => {
            quote.hub_id = params.hub_id;
            quote.transport_style = params.transport_style;
            quote.customer_id = params.customer_id;
            quote.email_to = params.emails.join(",");
            quote.dest_address = params.destination;
            quote.comment = params.comments;
            quote.private_comment = params.private_comment;
            if (quote.fees?.length) {
              quote.fees = quote.fees.map((fee) => ({
                ...fee,
                core: fee.core ?? false,
              }));
            }
            return quote;
          });
          let response = await this.$http.post("/api/v1/base_rates/quote", {
            quotes,
            target,
            intent,
          });
          this.$message({ message: response.data.message, type: "success" });
          await this.afterSave();
        }
      } catch (err) {
        this.$set(this.ar, "errors", err.response.data.errors);
      }
    },
    async afterSave() {
      switch (this.source) {
        case "SpotQuote":
          this.$emit("close");
          window.location.reload();
          break;
        case "ContainerCalculator":
          this.$emit("close");
          await ContainerCalculator.loadSpotQuotes();
          break;
        default:
          this.resetQuote();
          await this.$emit("loadCustomerQuotes");
          break;
      }
    },
    buildTollOptions(quote) {
      return {
        hub_id: quote.hub_id,
        uuid: quote.uuid,
        terminal_id: quote.terminal_id,
        destination: quote.destination,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.customer-quicker {
  @apply relative h-full overflow-auto;
  &.private {
    @apply p-2;
  }
  .box {
    .box-title {
      @apply px-2 py-1 uppercase text-xs font-bold text-gray-500 tracking-wide #{!important};
    }
    .box-content {
      @apply p-2 #{!important};
    }

    &.quoted {
      @apply border-green-400;
      .box-title {
        @apply bg-green-100 border-green-400;
      }
    }

    &.invalid {
      @apply border-pink-400;
      .box-title {
        @apply bg-pink-100 border-pink-400;
      }
    }
  }
  .el-form::v-deep {
    .el-form-item {
      @apply -mt-1;
    }
    .el-form-item__label {
      @apply uppercase text-2xs text-gray-500 tracking-wide -mb-1.5 #{!important};
    }
    .el-tag.el-tag--info {
      @apply bg-blue-100  #{!important};
      .el-select__tags-text {
        @apply text-blue-700 text-2xs font-bold #{!important};
      }
      .el-tag__close {
        @apply bg-blue-100 text-blue-700 hover:bg-blue-200 #{!important};
      }
    }
  }
  .destination-query {
    @apply flex items-center justify-between w-[425px];
  }
  .size-type-weight::v-deep {
    .equipment-checkboxes {
      @apply flex items-center gap-1 absolute right-0 -top-[22px] #{!important};
      .el-checkbox {
        @apply h-4 px-0 #{!important};
        .el-checkbox__inner {
          @apply size-3;
          &::after {
            @apply h-2 left-1 top-0;
          }
        }
        .el-checkbox__label {
          @apply text-[11px] font-bold;
        }
      }
    }
  }
  .rating-tabs {
    @apply min-w-0 flex flex-row-reverse items-stretch;
    overflow: visible !important;
  }
  .rating-tabs::v-deep {
    .el-tabs__header.is-right {
      @apply ml-2 mb-0 w-64 shrink-0 self-stretch border;
      float: none !important;
      height: auto !important;
    }
    .el-tabs__content {
      @apply p-0 flex-1 min-w-0 #{!important};
    }
    .el-tabs__nav-wrap.is-right {
      @apply pl-0 h-full;
      &::after {
        @apply w-px h-full bg-gray-200;
      }
    }
    .el-tabs__item {
      @apply h-auto px-2 py-0.5  leading-tight text-left;
    }
    .el-tabs__item.is-active {
      @apply bg-sky-50 font-bold;
    }
    .el-tab-pane {
      @apply min-w-0;
    }
  }
  .quote-meta::v-deep {
    @apply text-xs flex items-center gap-1;
    .expr-date {
      @apply w-20;
      .el-input__icon {
        @apply text-xs #{!important};
      }
      .el-input__inner {
        @apply pl-5 pr-0.5 tracking-tight font-bold #{!important};
      }
      .el-input__suffix {
        @apply hidden #{!important};
      }
    }
  }
  .quote::v-deep {
    @apply bg-white rounded-sm w-full;
    .header {
      @apply p-1 #{!important};
    }
    .fees {
      @apply border rounded divide-y divide-gray-100;
      .header {
        @apply px-2 py-1 border-b flex items-center justify-between rounded-t;
      }
      .base-subtotal {
        @apply bg-gray-50 border-b border-gray-200;
        .title {
          @apply text-left text-xs uppercase;
        }
      }
      &.core {
        @apply border-blue-200;
        .header {
          @apply bg-blue-50 border-b border-blue-200;
          .title {
            @apply text-2xs uppercase bg-blue-600 text-white px-2 rounded-sm;
          }
        }
        .summary {
          @apply bg-blue-50 border-t border-blue-200 rounded-b;
          .title {
            @apply text-left text-xs uppercase;
          }
        }
      }
      &.applicable {
        @apply border-orange-200;
        .header {
          @apply bg-orange-50 border-b border-orange-200;
          .title {
            @apply text-2xs uppercase bg-red-500 text-white px-2 rounded-sm;
          }
        }
        .summary {
          @apply bg-orange-50 border-t border-orange-200 rounded-b;
          .title {
            @apply text-left text-xs uppercase;
          }
        }
      }

      .el-date-editor {
        @apply h-6;
        .el-input__prefix {
          @apply -mt-0.5;
        }
      }
      .el-input {
        @apply max-w-[96px];

        input.el-input__inner {
          @apply text-sm h-6 leading-6 font-bold text-right text-blue-600;
        }
      }
    }

    .section {
      @apply flex flex-col divide-y m-0.5 border border-gray-400 shadow rounded empty:hidden;
    }

    .el-input.el-input-group {
      vertical-align: middle !important;
    }

    .vs {
      @apply grid grid-cols-4 gap-1 text-xs items-center relative px-2 py-0.5 font-semibold hover:bg-blue-50;

      &.extra-fee {
        @apply border-pink-300 bg-pink-100;
      }
      .actions {
        @apply col-span-2  flex items-center justify-between;
        .links {
          @apply flex items-center gap-1 opacity-60 hover:opacity-100;
        }
      }

      b {
        @apply font-semibold tracking-tighter truncate #{!important};
        &.details {
          @apply text-2xs italic;
        }
      }

      & > div {
        @apply text-right pl-1 text-gray-500 font-bold;
      }

      .below {
        @apply absolute top-6 right-1 border italic text-3xs leading-3 font-semibold w-auto z-10;
      }
    }
  }
}
.customer-quicker::v-deep {
  &.private {
    .el-drawer__wrapper:not(:has(.batch-fees-drawer)) {
      @apply absolute inset-2.5 #{!important};
    }
  }
  .el-drawer__wrapper:has(.batch-fees-drawer) {
    @apply sticky top-0 z-20 w-full overflow-visible #{!important};
    right: 0 !important;
    left: 0 !important;
    bottom: auto !important;
    height: 0 !important;
    pointer-events: none;
  }
  .el-drawer__wrapper:has(.batch-fees-drawer) .el-drawer__container {
    @apply h-auto w-full;
    pointer-events: none;
  }
  .batch-fees-drawer {
    @apply border border-blue-600 bg-white #{!important};
    pointer-events: auto;
    .el-drawer__header {
      @apply bg-blue-600 text-white border-b mb-1.5 p-1 #{!important};
    }
    .el-drawer__body {
      @apply px-2 #{!important};
    }
  }
  .batch-fees {
    .el-form {
      @apply px-1.5 bg-gray-50 border rounded-sm;
    }
  }
}
</style>
